import React from 'react';
import Card from '@/components/card';
import { Button, Typography } from 'antd';
import {
  // CheckCircleFilled,
  // CloseCircleFilled,
  EditFilled,
} from '@ant-design/icons';
import Title from '@/components/title';
import { DetailItem } from '@/components/dataItem/data-view-item';
import { twMerge } from 'tailwind-merge';
import { ICustomer } from '@/interfaces/customer';
import { getFullAddress } from '@/utils/customerUtils';
import BreadcrumbComponent from '@/components/breadcrumb';
import { useNavigate } from 'react-router-dom';
import { getPaymentCategoryName } from '@/helpers/customerHelper';
import { EPaymentCategory } from '@/enums/ECustomerType';
// import { useSetting } from '@/contexts/CompanyContext';

interface IProps {
  data?: ICustomer;
  onEdit?: () => void;
}

const CustomerDetail = ({ data, onEdit }: IProps) => {
  const navigate = useNavigate();
  // const { setting } = useSetting();
  return (
    <Card>
      <BreadcrumbComponent
        items={[
          {
            title: (
              <div
                className="cursor-pointer"
                onClick={() => navigate(`/customer`)}
              >
                ลูกค้าทั้งหมด
              </div>
            ),
          },
          {
            title: `${data?.name || ''}`,
          },
        ]}
      />
      <Title customClassName="text-lg text-blue-700" title={`รายละเอียด`}>
        <div className="flex flex-row gap-2">
          <div
            className={twMerge(
              'min-w-[100px] w-full text-center p-1.5 rounded font-bold bg-green-200 text-green-600',
              !data?.isActive && ' bg-red-200 text-red-600',
            )}
          >
            {data?.isActive ? 'ใช้งานอยู่' : 'ไม่ได้ใช้งาน'}
          </div>
          <Button type="primary" onClick={onEdit}>
            <EditFilled />
            แก้ไข
          </Button>
        </div>
      </Title>
      <div className="grid md:grid-cols-2 lg:grid-cols-2 w-full gap-3 mt-3">
        <DetailItem
          label="ประเภทลูกค้า"
          detail={data?.customerType === 1 ? 'Direct' : 'Distributor'}
        />
        <DetailItem
          label="ประเภทวางบิลรับเงิน"
          detail={getPaymentCategoryName(
            data?.paymentCategory as EPaymentCategory,
          )}
        />
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-2 w-full gap-3 mt-3">
        <DetailItem label="รหัส" detail={data?.code || ''} />
        <DetailItem label="ลูกค้า" detail={data?.name} />
        <DetailItem label="เลขผู้เสียภาษี" detail={data?.taxId} />
        <DetailItem label="สาขา" detail={data?.branchId || '-'} />
        <DetailItem label="เบอร์ติดต่อ" detail={data?.phoneNumber} />
        <DetailItem
          label="เครดิตเทอม"
          detail={`${data?.creditTerm || 0} วัน`}
        />
        <DetailItem label="Business Unit" detail={data?.businessUnitName} />
        <DetailItem label="ผู้ขาย" detail={data?.salesName} />
      </div>
      {/* <div className="grid md:grid-cols-2 lg:grid-cols-2 w-full gap-3 mt-3">
        <DetailItem label="Ref 1" detail={setting?.referenceCode} />
        <DetailItem label="Ref 2" detail={data?.code} />
      </div> */}
      <div className="flex flex-col gap-3 mt-3">
        <DetailItem label="ที่อยู่" detail={getFullAddress(data)} />
        <DetailItem
          label="Google Map"
          detail={
            <Typography.Link
              href={data?.maplink}
              target="_blank"
              copyable={{ text: data?.maplink }}
              className="underline text-blue-700 cursor-pointer"
            >
              map link
            </Typography.Link>
          }
        />
        {/* <DetailItem
          label="แนบ QR CODE สินค้า"
          detail={
            data?.isProductQrCode ? (
              <span className="text-green-600 font-bold">แนบ QR CODE</span>
            ) : (
              'ไม่ใช้งาน'
            )
          }
        />
        <DetailItem
          label="เครือ CP"
          detail={
            data?.isCP ? (
              <CheckCircleFilled className="text-green-600" />
            ) : (
              <CloseCircleFilled className="text-red-600" />
            )
          }
        /> */}
      </div>
    </Card>
  );
};

export default CustomerDetail;
